<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">财务系统</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>批量归集白名单</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card shadow="never" class="page-content">
      <!-- 转出账户和接收账户并排布局 -->
      <div class="table-container">
        <!-- 转出账户列表 -->
        <div class="master-list">
          <div class="page-actions">
            <el-button type="primary" @click="handleAddMaster">添加转出账户</el-button>
          </div>
          <el-table
              :data="paginatedMasterAccounts"
              border
              :row-class-name="setRowClassName"
              :row-style="highlightRowStyle"
              @row-click="selectMaster"
          >
            <el-table-column label="转出账户UID" width="230">
              <template slot-scope="scope">
                {{ scope.row }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="230">
              <template slot-scope="scope">
                <el-button
                    type="primary"
                    icon="el-icon-edit"
                    circle
                    size="small"
                    @click.native.stop="handleEditMaster(scope.row)"
                ></el-button>
                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="small"
                    @click.native.stop="handleDeleteMaster(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="pageSize"
              :current-page="currentPage"
              @current-change="handlePageChange"
              @size-change="handleSizeChange"
          ></el-pagination>
        </div>

        <div class="sub-list">
          <div class="page-actions">
            <el-button type="primary" :disabled="currentMaster === ''" @click="handleAddSub">添加接收账户</el-button>
            <div class="current-master-hint">当前转出账户：<label style="color: #e2696a">{{ currentMaster }}</label></div>
          </div>
          <el-table :data="subAccounts" border>
            <el-table-column label="接收账户UID">
              <template slot-scope="scope">
                {{ scope.row }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    size="small"
                    @click="handleDeleteSub(scope.$index)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'TransferApprovalWhitelist',
  data() {
    return {
      currentPage: 1,
      pageSize: 10
    };
  },
  async mounted() {
    await this.fetchWhitelist();
  },
  computed: {
    ...mapState('transferApprovalWhitelist', ['whitelist', 'currentMaster', 'masterOrder']),
    masterAccounts() {
      return this.masterOrder || [];
    },
    paginatedMasterAccounts() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.masterAccounts.slice(start, end);
    },
    total() {
      return this.masterAccounts.length;
    },
    subAccounts() {
      return this.currentMaster ? this.whitelist[this.currentMaster] : [];
    }
  },
  methods: {
    setRowClassName({ row }) {
      return row === this.currentMaster ? 'highlight-row' : '';
    },
    highlightRowStyle({ row }) {
      return row === this.currentMaster
          ? {
            'background-color': '#ebedf0',
            'color': '#55a4ed',
            'font-weight': '500'
          }
          : null;
    },
    ...mapActions('transferApprovalWhitelist', ['fetchWhitelist', 'updateList', 'updateMasterList']),
    handlePageChange(page) {
      this.currentPage = page;
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
    },
    selectMaster(master) {
      this.$store.commit('transferApprovalWhitelist/setCurrentMaster', master);
    },

    handleAddMaster() {
      this.$prompt('请输入转出账户UID', '添加转出账户', {
        inputPattern: /^\d+$/,
        inputErrorMessage: '请输入有效的数字UID'
      }).then(({ value }) => {
        return this.updateMasterList({ newKey: value });
      }).then(() => {
        this.$message.success('转出账户添加成功');
        this.fetchWhitelist();
      }).catch((error) => {
        if (error !== 'cancel') {
          this.$message.error('添加转出账户失败');
        }
      });
    },

    handleEditMaster(master) {
      this.$prompt('请输入新的转出账户UID', '编辑转出账户', {
        inputValue: master, // 预填充当前转出账户UID
        inputPattern: /^\d+$/,
        inputErrorMessage: '请输入有效的数字UID'
      }).then(({ value }) => {
        if (value === master) {
          this.$message.info('未进行修改');
          return;
        }
        return this.updateMasterList({
          oldKey: master,
          newKey: value
        });
      }).then(() => {
        this.$message.success('转出账户修改成功');
        this.fetchWhitelist();
      }).catch((error) => {
        if (error !== 'cancel') {
          this.$message.error('修改转出账户失败');
        }
      });
    },

    async handleDeleteMaster(master) {
      try {
        await this.$confirm('确认删除该转出账户及其所有接收账户？', '提示', { type: 'warning' });
        await this.updateMasterList({
          oldKey: master,
        });
        this.$message.success('删除成功');

        await this.fetchWhitelist();
        this.$store.commit('transferApprovalWhitelist/setCurrentMaster', null);

        if (this.paginatedMasterAccounts.length === 0 && this.currentPage > 1) {
          this.currentPage -= 1;
        }
      } catch (e) {}
    },

    handleAddSub() {
      this.$prompt('请输入接收账户UID（归属转出账户：' + this.currentMaster + '）', '添加接收账户', {
        inputPattern: /^\d+$/,
        inputErrorMessage: '请输入有效的数字UID'
      }).then(({ value }) => {
        if (!value) return;

        const currentSubs = this.subAccounts;
        if (currentSubs.includes(value)) {
          this.$message.warning('该接收账户已存在');
          return;
        }

        const newSubs = [...currentSubs, value];
        this.updateList(newSubs);
        this.$message.success('接收账户添加成功');
      }).catch(() => {
        // 取消操作
      });
    },

    async handleDeleteSub(index) {
      await this.$confirm('确认删除该接收账户？', '提示', { type: 'warning' });
      const newSubs = [...this.subAccounts];
      newSubs.splice(index, 1);
      this.updateList(newSubs);
      this.$message.success('接收账户删除成功');
    }
  }
};
</script>

<style scoped>
.table-container {
  display: flex;
  gap: 0; /* 确保子元素之间没有间距 */
  padding: 0; /* 移除内边距 */
  border: none; /* 移除边框 */

  /* 调整弹性布局的对齐方式 */
  align-items: stretch;
  justify-content: flex-start; /* 修改：使子元素靠左对齐 */
}

.master-list {
  flex: 1;
  max-width: 462px;
  margin-left: 0; /* 删除负边距 */
}

.sub-list {
  flex: 1;
  max-width: 460px;
  margin-left: 15px; /* 添加固定间距 */
}

/* 当前转出账户提示 */
.current-master-hint {
  margin-right: 15px;
  color: #4799f5;
  font-size: 14px;
}
</style>
